import { render, staticRenderFns } from "./guessOrder.vue?vue&type=template&id=64cd6af4&scoped=true&"
import script from "./guessOrder.vue?vue&type=script&lang=js&"
export * from "./guessOrder.vue?vue&type=script&lang=js&"
import style0 from "./guessOrder.vue?vue&type=style&index=0&id=64cd6af4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cd6af4",
  null
  
)

export default component.exports